"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configuration_1 = require("@common/configuration");
const app_service_1 = require("./app.service");
class HouskeeperService extends app_service_1.AppService {
    constructor(token) {
        super(token);
        this.endpoint = "";
        this.endpoint = configuration_1.Configuration.unitsServiceConfig().api;
    }
    async getGwUnitStaffers(unitId) {
        const result = await this.httpService.get(`${this.endpoint}/gw_unit_staffers?filter[unit]=${unitId}&filter[staffer_type]=cx_contact`, {
            headers: this.getHeaders(),
        });
        return result.data;
    }
}
exports.HouskeeperService = HouskeeperService;
//# sourceMappingURL=housekeeper.service.js.map